import React from 'react';
import { Menu, X } from 'lucide-react';
import { NavLink } from './ui/CommonComponents';
import LanguageSwitcher from './ui/LanguageSwitcher';
import { useTranslation } from '../hooks/useTranslation';

export const Navigation = ({ activeSection, scrolled, isMenuOpen, setIsMenuOpen, scrollToSection }) => {
    const { t } = useTranslation();
    const navItems = ['home', 'about', 'experience', 'skills', 'projects', 'education', 'hackathons', 'contact'];

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-[#0d0d0d]/95 backdrop-blur-md border-b border-[#732424]/30 py-4' : 'bg-transparent py-6'}`}>
            <div className="container mx-auto px-6 flex justify-between items-center">
                <div className="text-2xl font-bold tracking-tighter cursor-pointer group" onClick={() => scrollToSection('home')}>
                    TAHER<span className="text-[#d92323]">.</span>AYADI
                </div>

                {/* Desktop Menu */}
                <div className="hidden lg:flex items-center gap-2">
                    {navItems.map((item) => (
                        <NavLink
                            key={item}
                            href={item}
                            label={t(item)}
                            active={activeSection === item}
                            onClick={scrollToSection}
                        />
                    ))}
                    <LanguageSwitcher />
                </div>

                {/* Mobile Menu Button */}
                <button className="lg:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    {isMenuOpen ? <X /> : <Menu />}
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {isMenuOpen && (
                <div className="lg:hidden absolute top-full left-0 w-full bg-[#0d0d0d] border-b border-[#732424]/30 p-6 flex flex-col gap-4 animate-in slide-in-from-top-5">
                    {navItems.map((item) => (
                        <button
                            key={item}
                            onClick={() => scrollToSection(item)}
                            className="text-left text-lg font-medium text-[#7b7b7b] hover:text-[#d92323] transition-colors"
                        >
                            {t(item)}
                        </button>
                    ))}
                    <div className="pt-4 border-t border-[#732424]/30">
                        <LanguageSwitcher />
                    </div>
                </div>
            )}
        </nav>
    );
};